import { render, staticRenderFns } from "./CourseBySelf.vue?vue&type=template&id=1d1529a6&scoped=true&"
import script from "./CourseBySelf.vue?vue&type=script&lang=js&"
export * from "./CourseBySelf.vue?vue&type=script&lang=js&"
import style0 from "./CourseBySelf.vue?vue&type=style&index=0&id=1d1529a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1529a6",
  null
  
)

export default component.exports